import { useNavigate } from 'react-router-dom';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { Box, Button, Chip, CircularProgress, IconButton, Typography } from '@mui/material';

interface MergeCustomizationHeaderProps {
  selectedCount: number;
  isMerging: boolean;
  onConfirm: () => void;
}

export function MergeCustomizationHeader({
  selectedCount,
  isMerging,
  onConfirm,
}: MergeCustomizationHeaderProps) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        mb: 3,
        flexWrap: 'wrap',
      }}
    >
      <IconButton
        onClick={() => navigate('/patients/merge')}
        size="small"
        aria-label="Back to patient deduplication"
      >
        <ArrowBackIcon />
      </IconButton>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="h5" noWrap sx={{ fontWeight: 700 }}>
          Customize Merge
        </Typography>
      </Box>

      <Button
        variant="contained"
        onClick={onConfirm}
        disabled={isMerging}
        sx={{ textTransform: 'none', fontWeight: 600, px: 2.5, borderRadius: 2 }}
      >
        {isMerging ? <CircularProgress size={18} sx={{ mr: 1 }} /> : null}
        Confirm Merge
        <Chip
          label={selectedCount}
          size="small"
          sx={{ ml: 1, height: 20, fontSize: '0.7rem', color: 'inherit', backgroundColor: 'rgba(255,255,255,0.2)' }}
        />
      </Button>
    </Box>
  );
}
